import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { Tag } from '@/types/models';

const COLLECTION = 'tags';

function docToTag(
  d: { id: string },
  data: Record<string, unknown>,
): Tag {
  return {
    id: d.id,
    groupId: data.groupId as string,
    churchId: data.churchId as string,
    taskId: data.taskId as string | undefined,
    reasonId: data.reasonId as string | undefined,
  };
}

export async function getTagsByTask(taskId: string): Promise<Tag[]> {
  const q = query(
    collection(db, COLLECTION),
    where('taskId', '==', taskId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => docToTag(d, d.data()));
}

export async function getTagsByReason(reasonId: string): Promise<Tag[]> {
  const q = query(
    collection(db, COLLECTION),
    where('reasonId', '==', reasonId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => docToTag(d, d.data()));
}

export async function getTagsByGroup(groupId: string): Promise<Tag[]> {
  const q = query(
    collection(db, COLLECTION),
    where('groupId', '==', groupId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => docToTag(d, d.data()));
}

export async function getTagsByChurch(churchId: string): Promise<Tag[]> {
  const q = query(
    collection(db, COLLECTION),
    where('churchId', '==', churchId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => docToTag(d, d.data()));
}

export async function addTag(
  data: Omit<Tag, 'id'>,
): Promise<string> {
  const tagData: Record<string, string> = {
    groupId: data.groupId,
    churchId: data.churchId,
  };
  if (data.taskId) tagData.taskId = data.taskId;
  if (data.reasonId) tagData.reasonId = data.reasonId;

  const ref = await addDoc(collection(db, COLLECTION), tagData);
  return ref.id;
}

export async function removeTag(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTION, id));
}
